var render = function render(){var _vm=this,_c=_vm._self._c;return (this.entityByName('basicSettings'))?_c('div',{staticClass:"rounded text-white px-5",class:'bg-' + this.entityByName('basicSettings').bannerVariant},[_vm._v(" "+_vm._s(this.entityByName("basicSettings").bannerText)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }